<style lang="less" scoped>
.large-market{
  &__banner{
    width: 100%;
    object-fit: contain;
  }
  &__tips{
    font-size: 12px;
    line-height: 18px;
    color: #333330;
    text-align: center;
    padding: 20px 0 40px;
    &__focus{
      margin-left: 4px;
      color: #2A89F4;
    }
  }
}

</style>
<template>
  <div class="large-market">
    <img src="https://s6.bihukankan.com/img/16923286101.png" alt="banner" class="large-market__banner">
    <van-tabs sticky color="#2A89F4" >
      <van-tab title="直播流量大盘" to="/largeMarket/stream" replace/>
      <van-tab title="商品销售大盘" to="/largeMarket/goods" replace/>
    </van-tabs>
    <router-view />
    <div class="large-market__tips">
      更多数据登陆电脑端查看~
      <div>https://www.bihukankan.com
        <span  id="copy-btn" @click="copy" data-clipboard-text="https://www.bihukankan.com" class="large-market__tips__focus">复制</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods:{
    copy(){
      const clipboard = new ClipboardJS('#copy-btn');
      clipboard.on('success', function (e) {
        e.clearSelection();
      });
      this.$dialog.alert({
        message: '复制成功'
      })
    }
  }
}
</script>